import { styled } from '@mui/material';

export const ContentWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '72px',

  [theme.breakpoints.down('2xl')]: {
    gap: '44px',
  },
  [theme.breakpoints.down('lg')]: {
    gap: '40px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '36px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '32px',
  },
}));
